
import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedPaymentStepWithI18n } from './delayed-payment-step';

export const PaymentStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.PAYMENT,
  render: () => <DelayedPaymentStepWithI18n />,
};

export const PreviewPaymentStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_PAYMENT,
  render: () => <DelayedPaymentStepWithI18n />,
};
